import {DeviceType} from './device';

export const PROTOCOL_FORMULA = 'formula' as const;

export type Protocol = DeviceType | typeof PROTOCOL_FORMULA;
